<template>
    <div>
        <div v-if="!historico">
            <div
                class="row col-12 pb-3 px-0 m-0 d-flex justify-content-between"
            >
                <h4 class="font-weight-bold">Trabalho e Remuneração</h4>

                <a
                    class="font-weight-light font-italic"
                    role="button"
                    @click="historico = true"
                >
                    <i class="mdi mdi-history"></i>Histórico
                </a>
            </div>
            <div class="row">
                <form-select
                    grid="12"
                    label="Possui qualificação profissional?"
                    v-model="remuneracao.qualificacao_profissional"
                    :itens="$root.arrays.pergunta"
                />
                <form-select
                    v-model="remuneracao.profissao_nome"
                    :itens="$root.ocupacoes"
                    label="Qual sua profissão de acordo com a CLASSIFICAÇÃO BRASILEIRA DE OCUPAÇÕES ?"
                    :disabled="
                        remuneracao.qualificacao_profissional == 1
                            ? false
                            : true
                    "
                    ajuda="Se o sistema não localizar os dados pesquisado, o que foi digitado será salvo neste campo após clicar em salvar."
                />

                <form-select
                    grid="12"
                    label="Na semana passada trabalhou?"
                    v-model="remuneracao.trabalhou"
                    :itens="$root.arrays.pergunta"
                />
                <form-select
                    label="Neste trabalho principal era:"
                    v-model="remuneracao.profissao_principal"
                    :itens="$root.arrays.profissao_principal"
                />
                <form-select
                    label="Na semana passada estava afastado de um trabalho, por motivo de doença, falta voluntária, licença, férias ou por outro motivo?"
                    v-model="remuneracao.afastado"
                    :itens="$root.arrays.pergunta"
                />
                <form-select
                    label="Esse trabalho principal que exerceu foi na agricultura, criação de animais, pesca ou coleta (extração vegetal)?"
                    v-model="remuneracao.trabalho_agricultura"
                    :itens="$root.arrays.pergunta"
                />
                <form-select
                    grid="6"
                    label="No mês passado recebeu remuneração de trabalho?"
                    v-model="remuneracao.recebeu_remuneracao"
                    :itens="$root.arrays.pergunta"
                />

                <form-input
                    grid="6"
                    label="(Se sim, registre o valor bruto da remuneração efetivamente recebida)"
                    v-model="remuneracao.valor_remuneracao"
                    type="money"
                    inputGroup="true"
                    btnText="R$"
                    :readonly="
                        remuneracao.recebeu_remuneracao == '1' ? false : true
                    "
                />
                <h5 class="col-12 font-weight-bold">
                    VALOR RECEBIDO DE OUTRAS FONTES?
                </h5>
                <form-select
                    grid="4"
                    label="Trabalhou remunerado nos últimos 12 meses?"
                    :itens="$root.arrays.pergunta"
                    v-model="remuneracao.remuneracao_12_meses"
                />
                <form-input
                    grid="4"
                    inputGroup="true"
                    btnText="R$"
                    type="money"
                    label="Valor bruto de todos os trabalhos?"
                    v-model="remuneracao.remuneracao_valor_bruto"
                />
                <form-input
                    grid="4"
                    :type="'number'"
                    label="Quantos meses trabalhou?"
                    v-model="remuneracao.qtd_meses_trabalhados"
                />
                <form-select
                    grid="6"
                    label="Recebe aposentadoria por algum desses motivos:"
                    :itens="$root.arrays.aposentadoria_motivo"
                    v-model="remuneracao.aposentadoria_motivo"
                />
                <form-input
                    grid="6"
                    inputGroup="true"
                    btnText="R$"
                    type="money"
                    label="Valor da Aposentadoria"
                    v-model="remuneracao.aposentadoria_valor"
                />
                <form-select
                    grid="6"
                    label="Recebe algum desses benefícios"
                    :itens="$root.arrays.beneficios"
                    v-model="remuneracao.beneficio"
                />
                <form-input
                    grid="6"
                    inputGroup="true"
                    btnText="R$"
                    type="money"
                    label="Valor do Beneficiário"
                    v-model="remuneracao.beneficio_valor"
                />
                <h6 class="col-12 mt-3">
                    Quanto recebe, normalmente, por mês de:
                </h6>
                <form-input
                    grid="6"
                    inputGroup="true"
                    btnText="R$"
                    type="money"
                    label="Doação"
                    v-model="remuneracao.doacao_valor"
                />
                <form-input
                    grid="6"
                    inputGroup="true"
                    btnText="R$"
                    type="money"
                    label="Pensão alimentícia"
                    v-model="remuneracao.pensao_alimentar_valor"
                />
                <form-input
                    grid="6"
                    inputGroup="true"
                    btnText="R$"
                    type="money"
                    label="Seguro-desemprego"
                    v-model="remuneracao.seguro_desemprego_valor"
                />
                <form-input
                    grid="6"
                    inputGroup="true"
                    btnText="R$"
                    type="money"
                    label="Outras Rendas"
                    v-model="remuneracao.outras_rendas_valor"
                />
                <form-input
                    grid="6"
                    inputGroup="true"
                    btnText="R$"
                    :type="'number'"
                    label="Total"
                    v-model="sumRendas"
                    :readonly="true"
                />
                <h6 class="col-12 mt-4">
                    <i class="mdi mdi-alert-circle"></i>Aqui não devem ser
                    considerados recursos recebidos de Programas Sociais, tais
                    como BPC ou {{ $t("Bolsa Família") }} .
                </h6>
            </div>
            <div
                class="row col-12 pb-3 px-0 m-0 d-flex justify-content-between"
                v-if="disabledFromOsasco() == false"
            >
                <h4 class="font-weight-bold">Dados Bancários</h4>

                <button
                    class="btn btn-primary"
                    @click="$bvModal.show('create-conta-banco')"
                >
                    Cadastrar
                </button>
            </div>
            <div class="row">
                <div class="col-12" v-if="item.bancos.length > 0">
                    <table class="table table-sm border">
                        <thead class="table-active">
                            <tr class="font-weight-bold">
                                <td scope="col">Banco</td>
                                <td scope="col">Agência</td>
                                <td scope="col">Número da Conta</td>
                                <td scope="col">Tipo da Conta</td>
                                <td scope="col"></td>
                            </tr>
                        </thead>
                        <tbody v-if="item.bancos">
                            <tr
                                v-for="(banco, index) in item.bancos"
                                :key="banco.id"
                            >
                                <td scope="col">{{ banco.banco }}</td>
                                <td scope="col">{{ banco.agencia }}</td>
                                <td scope="col">{{ banco.conta_numero }}</td>
                                <td scope="col">
                                    {{
                                        banco.conta_tipo == 1
                                            ? "Corrente"
                                            : "Poupança"
                                    }}
                                </td>
                                <td scope="col">
                                    <button
                                        title="Excluir Conta Bancaria"
                                        @click="
                                            excluirContaBanco(banco.id, index)
                                        "
                                        class="btn px-2 mb-0 btn-danger btn-xs"
                                    >
                                        <i class="mdi mdi-close"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12" v-else>
                    <h4 class="text-secondary">
                        <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                        O usuário não possui conta cadastrada.
                    </h4>
                </div>
            </div>
            <div class="row pt-4 px-2 d-flex justify-content-end">
                <form-toggle
                    grid="9"
                    class="d-flex justify-content-end"
                    mt="0"
                    v-model="item.nova_condicao_remuneracao"
                    label="Cadastrar novos dados de Trabalho e Remuneração"
                />
                <button @click="submit" class="btn btn-success btn-submit">
                    <i class="mdi mdi-content-save"></i>
                    Salvar
                </button>
            </div>
        </div>
        <div v-else>
            <Historico
                :id="item.id"
                tipo="remuneracao"
                title="Trabalho e Remuneração"
                @voltar="historico = false"
            />
        </div>
        <ModalContaBanco :item="item" />
    </div>
</template>
<script>
import Historico from "../Historico/TrabalhoRemuneracao.vue";
import ModalContaBanco from "../ModalCadastrarContaBancaria";
export default {
    components: { Historico, ModalContaBanco },
    // directives: { money: Money },
    props: ["item"],
    data() {
        return {
            remuneracao: {},
            historico: false,
            disabled: true,
        };
    },
    computed: {
        sumRendas() {
            var valores = [
                this.checkValue(this.remuneracao.valor_remuneracao),
                this.checkValue(this.remuneracao.remuneracao_valor_bruto),
                this.checkValue(this.remuneracao.aposentadoria_valor),
                this.checkValue(this.remuneracao.doacao_valor),
                this.checkValue(this.remuneracao.pensao_alimentar_valor),
                this.checkValue(this.remuneracao.seguro_desemprego_valor),
                this.checkValue(this.remuneracao.outras_rendas_valor),
                this.checkValue(this.remuneracao.beneficio_valor),
            ];

            // var soma =
            return (this.remuneracao.total_rendas = valores.reduce(
                (a, b) => a + b
            ));
            // return soma;
        },
    },
    watch: {
        item(n, o) {
            this.setValue();
        },
    },
    beforeMount() {
        this.setValue();
    },
    methods: {
        disabledFromOsasco() {
            //
            if (window.location.hostname == "osascosp.suasfacil.com.br") {
                return true;
            } else {
                return false;
            }
        },
        setValue() {
            if (this.item.remuneracao != null) {
                this.remuneracao = this.item.remuneracao;
            }
        },
        checkValue(a) {
            return a == null ? 0 : parseInt(a);
        },
        submit() {
            this.item.remuneracao = this.remuneracao;
            this.$emit("submit");
        },
        excluirContaBanco(id, index) {
            axios
                .get(`api/dashboard/usuarios/contabanco/excluir/${id}`)
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.item.bancos.splice(index, 1);
                });
        },
    },
};
</script>
